// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    height: 'calc(var(--vh, 1vh) * 100 - 100px)',
    display: 'flex',
    flexDirection: 'column',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.pure-material-progress-circular::-webkit-progress-bar': {
      backgroundColor: 'transparent',
    },
    '.pure-material-progress-circular:indeterminate': {
      WebkitMaskImage:
        'linear-gradient(transparent 50%, black 50%), linear-gradient(to right, transparent 50%, black 50%)',
      maskImage: 'linear-gradient(transparent 50%, black 50%), linear-gradient(to right, transparent 50%, black 50%)',
      animation: 'pure-material-progress-circular 6s infinite cubic-bezier(0.3, 0.6, 1, 1)',
    },
    ':-ms-lang(x),\n  .pure-material-progress-circular:indeterminate': {
      animation: 'none',
    },
    '.pure-material-progress-circular:indeterminate::before, .pure-material-progress-circular:indeterminate::-webkit-progress-value': {
      content: "''",
      display: 'block',
      boxSizing: 'border-box',
      marginBottom: '0.25em',
      border: 'solid 0.25em transparent',
      borderTopColor: 'currentColor',
      borderRadius: '50%',
      width: '100% !important',
      height: '100%',
      backgroundColor: 'transparent',
      animation: '$pure-material-progress-circular-pseudo 0.75s infinite linear alternate',
    },
    '.pure-material-progress-circular:indeterminate::-moz-progress-bar': {
      boxSizing: 'border-box',
      border: 'solid 0.25em transparent',
      borderTopColor: 'currentColor',
      borderRadius: '50%',
      width: '100%',
      height: '100%',
      backgroundColor: 'transparent',
      animation: '$pure-material-progress-circular-pseudo 0.75s infinite linear alternate',
    },
    '.pure-material-progress-circular:indeterminate::-ms-fill': {
      animationName: '-ms-ring',
    },
  },
  '@keyframes pure-material-progress-circular': {
    '0%': { transform: 'rotate(0deg)' },
    '12.5%': { transform: 'rotate(180deg)', animationTimingFunction: 'linear' },
    '25%': { transform: 'rotate(630deg)' },
    '37.5%': { transform: 'rotate(810deg)', animationTimingFunction: 'linear' },
    '50%': { transform: 'rotate(1260deg)' },
    '62.5%': {
      transform: 'rotate(1440deg)',
      animationTimingFunction: 'linear',
    },
    '75%': { transform: 'rotate(1890deg)' },
    '87.5%': {
      transform: 'rotate(2070deg)',
      animationTimingFunction: 'linear',
    },
    '100%': { transform: 'rotate(2520deg)' },
  },
  '@keyframes pure-material-progress-circular-pseudo': {
    '0%': { transform: 'rotate(-30deg)' },
    '29.4%': { borderLeftColor: 'transparent' },
    '29.41%': { borderLeftColor: 'currentColor' },
    '64.7%': { borderBottomColor: 'transparent' },
    '64.71%': { borderBottomColor: 'currentColor' },
    '100%': {
      borderLeftColor: 'currentColor',
      borderBottomColor: 'currentColor',
      transform: 'rotate(225deg)',
    },
  },
});

interface Props {
  className?: string;
}

export default function Loading({ className }: Props) {
  const classes = useStyles();
  return (
    <div className={classnames(classes.root, className)}>
      <div style={{ flexGrow: 1 }} />
      <div className={classes.wrapper}>
        <progress className="pure-material-progress-circular" />
      </div>
      <div style={{ flexGrow: 1 }} />
    </div>
  );
}
